import useFetch from './use-fetch';
import useNonInitialFetch from './use-non-initial-fetch';

export { useNonInitialFetch };
export default useFetch;